import { addMany } from './helpers';

const state = {
  allIds: [],
  byId: {}
};

const getters = {
  find: state => id => state.byId[id],
  list: (state, getters) => state.allIds.map(id => getters.find(id)),

  findByVenueIds: (state, getters, _, rootGetters) => venueIds => {
    const venues = rootGetters['venues/findAll'](venueIds);
    return state.allIds
      .filter(id =>
        venues.some(v =>
          Array.isArray(v?.categories) &&
          v.categories.some(c => c.id === id)
        )
      )
      .map(id => getters.find(id));
  }
};

const actions = {
  addCategories: ({ commit }, categories) => {
    commit('addMany', categories);
  }
};

const mutations = {
  add: (state, category) => {
    state.byId[category.id] = category;
    if (state.allIds.includes(category.id)) return;
    state.allIds.push(category.id);
  },
  addMany: (state, categories) => addMany(state, categories)
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
